export const statuses = {
  open: 'Aberto',
  partial: 'Parcial',
  canceled: 'Cancelado',
  finished: 'Finalizado',
};

export function getName(value) {
  return statuses[value];
}
